import Vue from "vue";
// import { vm } from "@/main";

const getDefaultState = () => {
	return {
		layouts: null,
		layout: null,
		presets: [],
		preset: {
			name: "",
		},
		presetFolder: null,
		lastStateInterval: null,
		customLuts: [],
	};
};

const UserFiles = {
	namespaced: true,

	state: getDefaultState(),
	mutations: {
		RESET_STATE: state => {
			Object.assign(state, getDefaultState());
		},
		USER_FILE_FETCHED: () => {},
		SET_LAYOUTS: (state, payload) => {
			state.layouts = payload;
		},
		SET_LAYOUT: (state, payload) => {
			state.layout = payload;
		},
		LAYOUT_SAVED: () => {},
		USER_FILE_DELETED: () => {},
		FOLDER_DELETED: () => {},
		LAYOUT_RENAMED: () => {},
		LAST_STATE_FETCHED: () => {},
		IMAGE_STATE_POSTED: () => {},
		PRESETS_FETCHED: (state, payload) => {
			state.presets = payload;
		},
		PRESET_POSTED: () => {},
		SET_PRESET: (state, payload) => {
			state.preset = payload;
		},
		SET_PRESET_FOLDER: (state, payload) => {
			state.presetFolder = payload;
		},
		UNSET_PRESET_FOLDER: state => {
			state.presetFolder = null;
		},

		SET_LAST_STATE_INTERVAL: (state, payload) => {
			state.lastStateInterval = payload;
		},

		UNSET_LAST_STATE_INTERVAL: state => {
			clearInterval(state.lastStateInterval);
			state.lastStateInterval = null;
		},
	},
	actions: {
		resetState: ({ commit }) => {
			commit("RESET_STATE");
		},
		fetchLayouts: ({ commit, rootState }) => {
			Vue.prototype.$apiService.get(`accounts/${rootState.User.account.id}/layouts`).then(response => {
				// console.log(response.data);
				commit("SET_LAYOUTS", response.data);
			});
		},
		postLayout: ({ commit, rootState }, file) => {
			let formdata = new FormData();
			formdata.append(`files[0]`, file);

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/layouts`, formdata)
				.then(response => {
					commit("LAYOUT_SAVED");
					return response.data[0];
				})
				.catch(err => {
					console.log(err.response);
					return err;
				});
		},

		fetchFile: ({ commit, rootState }, url) => {
			return Vue.prototype.$S3Service
				.get(url)
				.then(response => {
					return response.data;
				})
				.catch(err => console.log(err.response));
		},

		selectLayout: ({ commit }, id) => {
			commit("SET_LAYOUT", id);
		},

		deleteUserFile: ({ commit, rootState }, file_id) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/files/${file_id}`)
				.then(response => {
					commit("USER_FILE_DELETED");
				})
				.catch(err => console.log(err.response));
		},

		renameLayout: ({ commit, rootState, state }, name) => {
			return Vue.prototype.$apiService
				.patch(`accounts/${rootState.User.account.id}/files/${state.layout}`, {
					name,
				})
				.then(response => {
					commit("LAYOUT_RENAMED");
				})
				.catch(err => console.log(err.response));
		},

		fetchLastState: ({ commit, rootState }, file_id) => {
			return new Promise((resolve, reject) => {
				Vue.prototype.$apiService
					.get(`accounts/${rootState.User.account.id}/projects/${rootState.Projects.project.id}/files/${file_id}/last-state`)
					.then(response => {
						commit("LAST_STATE_FETCHED");
						resolve(response.data);
					})
					.catch(err => {
						console.log(err);
						reject(err);
					});
			});
		},

		fetchLastStatesByProject: ({ rootState }, project_id) => {
			if (!project_id) project_id = rootState.Projects.project.id;

			return new Promise((resolve, reject) => {
				Vue.prototype.$apiService
					.get(`accounts/${rootState.User.account.id}/projects/${project_id}/files-last-state`)
					.then(response => {
						resolve(response.data);
					})
					.catch(err => {
						console.log(err);
						reject(err);
					});
			});
		},

		postLastState: ({ commit, rootState }, payload) => {
			let formdata = new FormData();
			payload.lastStates.forEach((lastState, key) => {
				formdata.append(`files[${key}][image_id]`, lastState.image_id);
				formdata.append(`files[${key}][file]`, lastState.file);
			});
			// if (!payload.project_id) payload.project_id = rootState.Projects.project.id;

			return Vue.prototype.$apiService
				.post(
					`accounts/${rootState.User.account.id}/projects/${payload.project_id}/files/${payload.lastStates[0].image_id}/last-state`,
					formdata
				)
				.then(() => {
					commit("IMAGE_STATE_POSTED");
					// return response.data[0];
				})
				.catch(err => {
					return err;
				});
		},

		fetchPresets: ({ commit, rootState }) => {
			return new Promise((resolve, reject) => {
				Vue.prototype.$apiService
					.get(`accounts/${rootState.User.account.id}/presets`)
					.then(response => {
						commit("PRESETS_FETCHED", response.data);
						resolve(response.data);
					})
					.catch(err => {
						console.log(err);
						reject(err);
					});
			});
		},

		postPreset: ({ commit, rootState }, payload) => {
			let formdata = new FormData();
			formdata.append(`file`, payload.file);
			formdata.append(`preset_name`, payload.presetName);
			if (typeof payload.folder_id !== "undefined") formdata.append(`folder_id`, payload.folder_id);
			else formdata.append(`folder_name`, payload.folderName);

			return Vue.prototype.$apiService
				.post(`accounts/${rootState.User.account.id}/presets`, formdata)
				.then(response => {
					commit("PRESET_POSTED");
					return response.data;
					// return response.data[0];
				})
				.catch(err => {
					console.log(err.response);
					return err;
				});
		},

		selectPreset: ({ commit }, preset) => {
			commit("SET_PRESET", preset);
		},

		selectPresetFolder: ({ commit }, id) => {
			commit("SET_PRESET_FOLDER", id);
		},

		deselectPresetFolder: ({ commit }) => {
			commit("UNSET_PRESET_FOLDER");
		},
		deleteFolder: ({ commit, rootState }, folder_id) => {
			return Vue.prototype.$apiService
				.delete(`accounts/${rootState.User.account.id}/folders/${folder_id}`)
				.then(response => {
					commit("FOLDER_DELETED");
				})
				.catch(err => console.log(err.response));
		},

		setLastStatePushInterval: ({ commit, state }) => {
			if (state.lastStateInterval) commit("UNSET_LAST_STATE_INTERVAL");

			let interval = setInterval(async () => {
				if (document.hidden) return;
				await window.lutify.storeLastState();
			}, 1000);


			commit("SET_LAST_STATE_INTERVAL", interval);
		},
	},
	getters: {
		selectedLayout: state => {
			if (state.layout) return state.layouts.find(layout => layout.id == state.layout);
			else return { name: "" };
		},
		presets: state => {
			return state.presets.filter(items => items.type == "sub_level_1");
		},
		presetsFromFolder: state => folder_id => {
			if (state.presets.find(items => items.id == folder_id)) return state.presets.find(items => items.id == folder_id).files;
		},
		presetFolder: state => {
			if (state.presetFolder) return state.presets.find(item => item.id == state.presetFolder);
			else return { id: null, name: null };
		},
	},
};

export default UserFiles;
